function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.886v16.978h20.455V3.977zM50 0L22.727 3.802v20.062H50zM0 26.136v16.978l20.455 2.909V26.136zm22.727 0v20.062L50 50V26.136z",
  fill: "#0079E0",
  fillRule: "evenodd"
});

function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTAgNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwNzlFMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCA2Ljg4NnYxNi45NzhoMjAuNDU1VjMuOTc3ek01MCAwTDIyLjcyNyAzLjgwMnYyMC4wNjJINTB6TTAgMjYuMTM2djE2Ljk3OGwyMC40NTUgMi45MDlWMjYuMTM2ek0yMi43MjcgMjYuMTM2djIwLjA2Mkw1MCA1MFYyNi4xMzZ6Ii8+PC9nPjwvc3ZnPgo=";
export { SvgWindows as ReactComponent };